import { ReduxAction } from '../core';
import { SearchPatient } from './types';

export class PatientsAction {
  public static PATIENT_SEARCH_CHANGED = `PATIENTS_SEARCH_CHANGED`;
  public static PATIENT_SET_SEARCHING = `PATIENTS_SET_SEARCHING`;
  public static PATIENT_SET_PATIENTS = `PATIENTS_SET_PATIENTS`;
}

export function patientSearchChanged(newValue: string): ReduxAction<string> {
  return {
    type: PatientsAction.PATIENT_SEARCH_CHANGED,
    data: newValue,
  };
}

export function setIsSearching(newValue: boolean): ReduxAction<boolean> {
  return {
    type: PatientsAction.PATIENT_SET_SEARCHING,
    data: newValue,
  };
}

export function setPatients(patients: SearchPatient[]): ReduxAction<SearchPatient[]> {
  return {
    type: PatientsAction.PATIENT_SET_PATIENTS,
    data: patients,
  };
}
